export const scrollToTop = (ref, instant?: boolean) => {
  ref.current &&
    ref.current.scrollTo({
      top: 0,
      behavior: instant ? 'instant' : 'smooth'
    })
}
